


<div [id]="elementId" class="aems-guidance-file-box" [ngClass]="{'center-content': seeAll && libraryName != 'AccessTrends-Resources','ml-4':libraryName == 'AccessTrends-Resources'}">
  <!-- <div class="add-file-header" [ngClass]="{'large': allGuidanceDocuments && allGuidanceDocuments.length > 8 && canAddDocument, 'small': allGuidanceDocuments && allGuidanceDocuments.length > 8 && !canAddDocument }"> -->
  <div class="add-file-header large">
    <h3>{{title}}</h3>
    <div class="header-buttons">
      <button class="add-new" *ngIf="canAddDocument && addButtonVisible === true" (click)="openNewDocumentSidebar()"><i class="icon icon-add MR5 top3"></i>ADD</button>
      <button class="see-all-btn" *ngIf="allGuidanceDocuments?.length > 8 || seeAll" (click)="toggleSeeAll()">
        <ng-container *ngIf="seeAll && libraryName != 'AccessTrends-Resources'">See less</ng-container>
        <ng-container *ngIf="!seeAll">See all</ng-container>
      </button>
    </div>
  </div>

 <div>
  <div class="empty-table" style="top: 0px; padding-top: 0; position: relative;" *ngIf="!loadPageData && libraryName == 'AccessTrends-Resources'">
    <div class="image-container" style="height: 209px;">
        <img src="assets/img/empty_filter.svg" alt="Empty Folder">
    </div>
    <p class="text">We didn't find anything to show here</p>
    <p class="subtext">Try removing filters to get results</p>
  </div>
 </div>

  <div class="add-file-list" *ngIf="mode==='List' || seeAll">
    <div class="add-file-item" *ngFor="let file of libraryItems">
      <a [href]="getViewFileUrl(file)" target="_blank">
        <div class="item-bg">
          <span class="icon-file"><svg><use attr.xlink:href="#icon-{{getFileIcon(file)}}"></use></svg></span>
          <img [src]="file.ThumbnailSafeUrl">
        </div>
        <div class="item-box">
          <h3>
            <span *ngIf="(file?.Title || file?.FileName)" data-mdb-toggle="tooltip" data-mdb-placement="top"
            [title]="(file?.Title || file?.FileName)">{{file?.Title || file?.FileName }}</span>
           <!--  <span *ngIf="(file?.FileName || file?.Title)?.length > 40 ">{{(file?.FileName || file?.Title) | slice:-27}}</span> -->
          </h3>
          <div class="item-user-info">
            <i></i>
            <p class="item-user-name">{{file.Editor.Title}}</p>
            <span class="item-user-edit">Edited {{file?.Modified | date :'MMMM d, y'}}</span>
          </div>
        </div>
      </a>
      <div class="actions-row">
        <button class="btn-delete" *ngIf="canDeleteDocument(file)" title="Delete" (click)="deleteFile(file)"><svg><use xlink:href="#icon-delete"></use></svg></button>
      </div>
    </div>
  </div>

  <p-carousel [value]="libraryItems" [numVisible]="2" [numScroll]="2" [responsiveOptions]="responsiveOptions" *ngIf="mode==='Carousel' && !seeAll" [circular]="true">
    <ng-template let-file pTemplate="item">
      <div class="add-file-item">
        <a [href]="getViewFileUrl(file)" target="_blank">
          <div class="item-bg">
            <span class="icon-file"><svg><use attr.xlink:href="#icon-{{getFileIcon(file)}}"></use></svg></span>
            <img [src]="file.ThumbnailSafeUrl">
          </div>
          <div class="item-box">
            <h3>
              <span>{{file?.Title || file?.FileName}}</span>
              <span *ngIf="(file?.Title || file?.FileName)?.length > 40 ">{{(file?.Title || file?.FileName) | slice:-27}}</span>
            </h3>
            <div class="item-user-info">
              <i></i>
              <p class="item-user-name">{{file.Editor.Title}}</p>
              <span class="item-user-edit">Edited {{file?.Modified | date :'MMMM d, y'}}</span>
            </div>
          </div>
        </a>
        <div class="actions-row">
          <button class="btn-delete" *ngIf="canDeleteDocument(file)" title="Delete" (click)="deleteFile(file)"><svg><use xlink:href="#icon-delete"></use></svg></button>
        </div>
      </div>
    </ng-template>
  </p-carousel>
</div>

<div class="sidebar size-S" [ngClass]="{'visible': sidebar.isSideBarVisible(guid)}">
  <ng-container  *ngIf="sidebar.isSideBarVisible(guid)">
    <app-add-document
      [title]="uploadDocumentTitle" [libraryName]="libraryName" [fileNameTreatment]="fileNameTreatment"
      [documentProperties]="documentProperties"
      [isLinkAllowed]="isLinkAllowed"
      (refreshDocuments)="refreshGuidanceDocuments($event)">
    </app-add-document>
  </ng-container>
</div>
